import styled from "styled-components"
import { ButtonBlue } from "./ButtonBlue";

export enum ButtonAction {
    None,
    Training,
    NewChallenge
}

export const BottomNavigation = (props: { 
    action?: ButtonAction | null
}) => {

    return (
        <Root>
            <Cell></Cell>
            <Cell>Skalborg Badminton</Cell>
            <Cell>
                 {(() => {
                    switch (props.action) {
                    case ButtonAction.NewChallenge:
                        return <ButtonBlue text="Spil igen" />;

                    case ButtonAction.Training:
                        return <ButtonBlue text="Træn din spiller" />;

                    case ButtonAction.None:
                        return null;

                    default:
                        return null
                    }
            })()}
            </Cell>
        </Root>
    )
}

const Cell = styled.div`
    flex: 1;
    position: relative;
    bottom: 4px;
`;

const Root = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 600;
    color: white;
    width: 100%;
    height: 60px;
    padding: 8px;
    border-top: 4px solid #C6895B;
    background-image: linear-gradient(#575757, #2C2C2C);;
`;